export default () => jQuery(($) => {
	$('#handbookPolicy__navigationForm select[name="policy"]').change(function () {
		$('#handbookPolicy__navigationForm').submit();
	});

	$('.handbookPolicy__reviewed-date--update').on('click', function (event) {
		event.preventDefault();

		var confirmationMessage = $(this).data('confirmation');
		var confirmed = confirm(confirmationMessage);
		var ajax_url = $(this).attr('href');
		if (!confirmed || !ajax_url) return false;

		$.get(
			ajax_url,
			function (data) {
				if (data && data.success) {
					alert(data.data.message);
					location.reload();
				} else {
					if (data && data.data && data.data.message) {
						console.log(data.data.message);
					}
					alert('Could not update "Last Reviewed" date. Please contact webmaster@carleton.edu');
				}
			});

		return false;
	});
});
